<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Sale Team Code"
                  v-model="saleTeam.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Sale Team Name"
                  v-model="saleTeam.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="saleTeam.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="saleTeam.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="saleTeam.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="saleTeam.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="saleTeam.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="saleTeam.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="saleTeam.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="saleTeam.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addCustomer()">
                    Add Customer
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="saleTeam.saleTeamDetailList.length > 0"
                >
                  <v-flex xs3>Customer Code</v-flex>
                  <v-flex xs5>Customer Name</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(detail, index) in saleTeam.saleTeamDetailList"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      placeholder="Customer Code"
                      v-model="detail.customerCode"
                      @click="showCustomers(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="detail.customerName"
                      label="Customer Name"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn icon @click="removeCustomer(index, detail.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Customer list dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Township"
                label="Township"
                type="text"
                class="mr-1"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelId"
                label="Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="customerList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setCustomer(props.item, selectedIndex),
                        (showCustomerListDialog = !showCustomerListDialog)
                    "
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.phoneNo }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { saleTeamService } from "../../services/sale-team-service";
import { SaleTeam, SaleTeamDetail } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { SaleTeamFormRules } from "../../helpers/validation-rules";
import { customerService } from "../../services/customer-service";
import { commonService } from "../../services/common-service";
import { creditLevelService } from "../../services/credit-level-service";

export default {
  name: "SaleTeamDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "SaleTeam",
        disabled: false,
        to: "sale-teams",
      },
      {
        text: "SaleTeam Detail",
        disabled: true,
      },
    ],
    updatedDate: "",
    createdDate: "",
    saleTeam: new SaleTeam(),
    oldSaleTeam: new SaleTeam(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new SaleTeamFormRules(),
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      township: "",
      creditLevelId: "",
    },
    showCustomerListDialog: false,
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", align: "left", value: "code" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    totalRows: 0,
    showListLoading: false,
    customerList: [],
    creditLevelList: [],
    selectedIndex: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
  },
  created() {
    this.getAllCreditLevels();
    const id = this.$route.params.id;
    if (id == "new") {
      // new saleTeam
    } else {
      this.getSaleTeamDetail(id);
    }
  },
  methods: {
    getAllCreditLevels(){
      creditLevelService
      .getCreditLevels()
      .then((res)=>{
        this.creditLevelList = res.data.creditLevelList;
        let findAll = { id: "", name: "---ALL---" };
        this.creditLevelList.unshift(findAll);
      })
    },
    addCustomer() {
      let saleTeamDetail = new SaleTeamDetail();
      this.saleTeam.saleTeamDetailList.push(saleTeamDetail);
    },
    removeCustomer(index, detailId) {
      if (detailId) {
        if (!this.saleTeam.deleteSaleTeamDetailIds) {
          this.saleTeam.deleteSaleTeamDetailIds = [];
        }
        this.saleTeam.deleteSaleTeamDetailIds.push(detailId);
      }
      this.$delete(this.saleTeam.saleTeamDetailList, index);
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getCustomerList();
    },
    showCustomers() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.township = "";
      this.queryParams.status = "ACTIVE";
      this.queryParams.creditLevelId = "";
      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getCustomerList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setCustomer(customer, index) {
      if (customer.id) {
        this.saleTeam.saleTeamDetailList[index].customerId = customer.id;
        this.saleTeam.saleTeamDetailList[index].customerCode = customer.code;
        this.saleTeam.saleTeamDetailList[index].customerName = customer.name;
      }
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.saleTeam.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        saleTeamService
          .saveSaleTeam(this.saleTeam)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getSaleTeamDetail(id) {
      saleTeamService
        .getSaleTeamDetail(id)
        .then((res) => {
          this.saleTeam = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.saleTeam.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.saleTeam.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldSaleTeam = Object.assign({}, res.data);
          this.statusFlag = this.saleTeam.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.saleTeam.id) {
        this.saleTeam = new SaleTeam();
        this.statusFlag = true;
      } else {
        this.saleTeam = Object.assign({}, this.oldSaleTeam);
        this.statusFlag = this.saleTeam.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/sale-teams");
    },
  },
};
</script>

